/* tslint:disable */
/* eslint-disable */
/**
 * API Gateway
 * This API provides user authentication and profile management.
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime'
import type { V1ProgrammeLesson } from './V1ProgrammeLesson'
import {
    V1ProgrammeLessonFromJSON,
    V1ProgrammeLessonFromJSONTyped,
    V1ProgrammeLessonToJSON,
    V1ProgrammeLessonToJSONTyped
} from './V1ProgrammeLesson'
import type { V1ProgrammeScheduleItem } from './V1ProgrammeScheduleItem'
import {
    V1ProgrammeScheduleItemFromJSON,
    V1ProgrammeScheduleItemFromJSONTyped,
    V1ProgrammeScheduleItemToJSON,
    V1ProgrammeScheduleItemToJSONTyped
} from './V1ProgrammeScheduleItem'

/**
 * Programme data with schedule filtered by day-by-day reveal rules
 * @export
 * @interface V1RevealedProgramme
 */
export interface V1RevealedProgramme {
    /**
     *
     */
    id?: string
    /**
     *
     */
    name?: string
    /**
     *
     */
    language?: string
    /**
     *
     */
    published?: boolean
    /**
     *
     */
    status?: string
    /**
     *
     */
    gender?: string
    /**
     *
     */
    minLevel?: string
    /**
     *
     */
    age?: string
    /**
     *
     */
    goals?: string
    /**
     *
     */
    description?: string
    /**
     *
     */
    lessons?: Array<V1ProgrammeLesson>
    /**
     *
     */
    schedule?: Array<V1ProgrammeScheduleItem>
    /**
     *
     */
    cost?: number
    /**
     * Total number of schedule days in the full programme (before reveal filtering)
     */
    totalDays?: number
    /**
     *
     */
    assignedCoachId?: string
}

/**
 * Check if a given object implements the V1RevealedProgramme interface.
 */
export function instanceOfV1RevealedProgramme(
    value: object
): value is V1RevealedProgramme {
    return true
}

export function V1RevealedProgrammeFromJSON(json: any): V1RevealedProgramme {
    return V1RevealedProgrammeFromJSONTyped(json, false)
}

export function V1RevealedProgrammeFromJSONTyped(
    json: any,
    ignoreDiscriminator: boolean
): V1RevealedProgramme {
    if (json == null) {
        return json
    }
    return {
        id: json['id'] == null ? undefined : json['id'],
        name: json['name'] == null ? undefined : json['name'],
        language: json['language'] == null ? undefined : json['language'],
        published: json['published'] == null ? undefined : json['published'],
        status: json['status'] == null ? undefined : json['status'],
        gender: json['gender'] == null ? undefined : json['gender'],
        minLevel: json['minLevel'] == null ? undefined : json['minLevel'],
        age: json['age'] == null ? undefined : json['age'],
        goals: json['goals'] == null ? undefined : json['goals'],
        description:
            json['description'] == null ? undefined : json['description'],
        lessons:
            json['lessons'] == null
                ? undefined
                : (json['lessons'] as Array<any>).map(
                      V1ProgrammeLessonFromJSON
                  ),
        schedule:
            json['schedule'] == null
                ? undefined
                : (json['schedule'] as Array<any>).map(
                      V1ProgrammeScheduleItemFromJSON
                  ),
        cost: json['cost'] == null ? undefined : json['cost'],
        totalDays: json['totalDays'] == null ? undefined : json['totalDays'],
        assignedCoachId:
            json['assignedCoachId'] == null
                ? undefined
                : json['assignedCoachId']
    }
}

export function V1RevealedProgrammeToJSON(json: any): V1RevealedProgramme {
    return V1RevealedProgrammeToJSONTyped(json, false)
}

export function V1RevealedProgrammeToJSONTyped(
    value?: V1RevealedProgramme | null,
    ignoreDiscriminator: boolean = false
): any {
    if (value == null) {
        return value
    }

    return {
        id: value['id'],
        name: value['name'],
        language: value['language'],
        published: value['published'],
        status: value['status'],
        gender: value['gender'],
        minLevel: value['minLevel'],
        age: value['age'],
        goals: value['goals'],
        description: value['description'],
        lessons:
            value['lessons'] == null
                ? undefined
                : (value['lessons'] as Array<any>).map(V1ProgrammeLessonToJSON),
        schedule:
            value['schedule'] == null
                ? undefined
                : (value['schedule'] as Array<any>).map(
                      V1ProgrammeScheduleItemToJSON
                  ),
        cost: value['cost'],
        totalDays: value['totalDays'],
        assignedCoachId: value['assignedCoachId']
    }
}
